// we cannot use the `Message` type from the SDK here because we will
// be writing this code before we upgrade to a new SDK version but they _should_

import { z } from "zod";

export const ItemEditorLtiEvents = {
  ITEM_EDITOR_CANCELLED: "itemEditorCancelled",
  ITEM_EDITOR_CLOSED: "itemEditorClosed",
  ITEM_EDITOR_OPENED: "itemEditorOpened",
  ITEM_METADATA_REQUESTED: "itemMetadataRequested",
  ITEM_HAS_UNSAVED_CHANGES: "itemHasUnsavedChanges",
  ITEM_CREATED: "itemCreated",
  ITEM_SAVED: "itemSaved",
  LAUNCHED: "launched",
} as const;

export const ItemEditorLtiEventSchema = z.union([
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemEditorLtiEvents.LAUNCHED),
    data: z.optional(z.unknown()),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemEditorLtiEvents.ITEM_SAVED),
    data: z.optional(z.unknown()),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemEditorLtiEvents.ITEM_CREATED),
    data: z.optional(z.unknown()),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemEditorLtiEvents.ITEM_EDITOR_OPENED),
    data: z.object({
      id: z.string().optional(), // opt'l if creating new item
    }),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemEditorLtiEvents.ITEM_METADATA_REQUESTED),
    data: z.object({
      fields: z.array(z.string()),
    }),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemEditorLtiEvents.ITEM_HAS_UNSAVED_CHANGES),
    data: z.object({
      modified: z.boolean(),
    }),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemEditorLtiEvents.ITEM_EDITOR_CLOSED),
  }),
  z.object({
    type: z.literal("event"),
    name: z.literal(ItemEditorLtiEvents.ITEM_EDITOR_CANCELLED),
    data: z.object({
      id: z.string().optional(), // opt'l if item was abandoned
    }),
  }),
]);

export type ItemEditorLtiEvent = z.infer<typeof ItemEditorLtiEventSchema>;
